
export function toString(value) {
    return '' + value;  // eslint-disable-line prefer-template
}

export function toNumber(value) {
    return Number(value);
}

export function toBoolean(value) {
    return !!value;
}
